import React from "react";
import { motion } from "framer-motion";
import { useContent } from "../context/ContentContext";

const ease = [0.16, 1, 0.3, 1];
const reveal = {
  hidden: { opacity: 0, y: 26 },
  show: (i = 0) => ({ opacity: 1, y: 0, transition: { duration: 0.8, delay: i * 0.1, ease } }),
};

export const About = () => {
  const { content } = useContent();
  const { company: COMPANY, about, stats: STATS } = content;
  return (
    <section id="chi-siamo" data-testid="about-section" className="relative py-24 md:py-36 bg-paper">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          {/* Image block */}
          <motion.div
            variants={reveal}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-100px" }}
            className="lg:col-span-5 relative"
          >
            <div className="relative">
              <img
                src={about.image}
                alt="Artigiano al lavoro"
                className="w-full h-[520px] object-cover"
              />
              <div className="absolute -bottom-8 -right-6 bg-navy text-paper px-10 py-7 hidden sm:block">
                <p className="font-serif text-5xl text-gold leading-none">{COMPANY.since}</p>
                <p className="text-[0.65rem] uppercase tracking-[0.25em] mt-2 text-paper/70">Anno di fondazione</p>
              </div>
              <div className="absolute -top-5 -left-5 w-24 h-24 border-t border-l border-gold" />
            </div>
          </motion.div>

          {/* Text block */}
          <div className="lg:col-span-7">
            <motion.p variants={reveal} initial="hidden" whileInView="show" viewport={{ once: true }} className="eyebrow mb-6">
              {about.eyebrow}
            </motion.p>
            <motion.h2
              variants={reveal}
              custom={1}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              className="font-serif font-light text-4xl md:text-5xl leading-tight text-navy"
            >
              {about.title}
            </motion.h2>
            <motion.p
              variants={reveal}
              custom={2}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              className="mt-7 text-navy/70 leading-relaxed text-base md:text-lg max-w-xl"
            >
              {about.paragraph1}
            </motion.p>
            <motion.p
              variants={reveal}
              custom={3}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              className="mt-4 text-navy/70 leading-relaxed text-base md:text-lg max-w-xl"
            >
              {about.paragraph2}
            </motion.p>

            <div className="mt-12 grid grid-cols-2 sm:grid-cols-4 gap-8 border-t border-gold/20 pt-10">
              {STATS.map((s, i) => (
                <motion.div
                  key={s.label}
                  variants={reveal}
                  custom={i}
                  initial="hidden"
                  whileInView="show"
                  viewport={{ once: true }}
                  data-testid={`stat-${i}`}
                >
                  <p className="font-serif text-3xl md:text-4xl text-navy">{s.value}</p>
                  <p className="text-[0.62rem] uppercase tracking-[0.18em] text-navy/50 mt-2 leading-snug">{s.label}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
